import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

/**
 * A route guard function that determines whether a user is allowed to activate a route.
 *
 * This guard checks if there is a currently authenticated user in the `AuthStore`.
 * If no user is found, it redirects the user to the login page and prevents route activation.
 *
 * @returns `true` if the user is authenticated and allowed to activate the route, otherwise `false`.
 */
export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  const isLoggedIn = authStore.isLoggedIn()

  if (isLoggedIn) {
    return true
  }

  router.navigate(['/login'])
  return false
}
